exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Week-2b12e188{display:flex}\n", ""]);

// Exports
exports.locals = {
	"Week": "Week-2b12e188"
};